import styled from 'styled-components'
import LogoTmovParceiros from '../../../../shared/assets/images/logo_parceiros.svg'
import { Tokens } from '@tmov/design-system/theme/types'

export { Button, CheckBox, Heading } from '@tmov/design-system'

const { colors } = Tokens.eixods

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  overflow: auto;
`
export const Header = styled.img.attrs({
  src: LogoTmovParceiros,
  alt: 'Logo tmov parceiros',
})`
  width: 360px;
  height: 60px;
  object-fit: cover;
  margin: 40px auto 0;
`
export const Main = styled.div`
  max-width: 1000px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 32px;
  padding: 24px;
  box-sizing: border-box;
  & > h4 {
    text-transform: uppercase;
    margin: 0 auto;
    color: ${colors.neutral.bg.dark};
  }
`
export const Action = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 24px;
  button {
    width: 120px;
  }
`

export const Content = styled.div`
  width: 100%;
  height: 400px;
  overflow: auto;
  padding: 24px;
  box-sizing: border-box;
  border: 2px solid ${colors.neutral.bg.dark};
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.neutral.bg.dark};
    border-radius: 10px;
    border: 2px solid white;
  }
`
